import { Button, type ButtonProps } from 'tcm-chakra-ui'

type StartNewEncounterButtonProps = Omit<ButtonProps, 'children'>

export function StartNewEncounterButton(props: StartNewEncounterButtonProps) {
  return (
    <Button
      colorPalette="red"
      variant="solid"
      css={{
        bg: 'background.surfaceError',
        color: 'text.white',
        px: 5,
        minH: 10,
        borderRadius: 'md',
        fontWeight: 700,
      }}
      {...props}
    >
      Close Encounter
    </Button>
  )
}
